<template lang="pug">
v-expansion-panel
  v-expansion-panel-header(color="#f7f9fc")
    h3(v-text="title")

  v-expansion-panel-content(color="#f7f9fc")
    v-card.card(flat, color="#f7f9fc")
      v-card-text
        v-row(v-if="!isEdit && !expert")
          v-col(md="3")
            v-btn(
              block,
              color="primary",
              :disabled="isNonEditable",
              @click="makeEdit"
            )
              v-icon(left) mdi-pencil
              span Edit
        slot(:isEdit="isEdit")
      v-card-actions(v-if="isEdit")
        v-spacer
        v-btn(text, @click="cancelEdit") cancel
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "flow_editor_wrapper",

  props: ["title", "expert"],

  data: () => ({
    isEdit: false,
  }),

  computed: {
    ...mapGetters("usercase", ["isNonEditable"]),
  },

  methods: {
    cancelEdit() {
      this.isEdit = false;
    },

    makeEdit() {
      if (!this.isEdit) this.isEdit = true;
    },
  },
};
</script>

<style lang="sass" scoped>
.dot
  width: 10px
  height: 10px
  border-radius: 50%

.overlays
  position: absolute
  top: 0
  bottom: 0
  left: 0
  right: 0
  display: flex
  align-items: center
  justify-content: center
  height: 100%
  transition: all .3s

  &:hover
    background-color: rgba(225,238,253, .4)

    .inner
      display: flex

.overlay
  flex: 1
  height: 100%
  transition: all .3s

  &:hover
    background-color: rgba(225,238,253, .8)

  .inner
    display: flex
    align-items: center
    justify-content: center
    height: 100%
    display: none

.v-card
  position: relative
  transition: background-color .3s

.on-hover
  cursor: pointer
</style>